// components/Atoms/Logo/Logo.js
import React from 'react';
import PropTypes from 'prop-types';
import Image from '../Image';

const Logo = ({ 
  image, 
  alt, 
  className = '',
  size = 'lg',
  grayscale = false  // CHANGED: false by default
}) => {
  if (!image) return null;

  // CHANGED: Bigger size variants for logos
  const sizeClasses = {
    sm: 'w-24 h-20',      // Small: 96x80px
    md: 'w-32 h-24',      // Medium: 128x96px  
    lg: 'w-40 h-32',      // Large: 160x128px (DEFAULT)
    xl: 'w-48 h-40'       // XL: 192x160px
  };

  const sizeClass = sizeClasses[size] || sizeClasses.lg;

  const logoClasses = [
    'flex items-center justify-center',
    'p-space-md',  // CHANGED: More padding
    grayscale ? 'grayscale hover:grayscale-0' : '',
    'opacity-90 hover:opacity-100',  // CHANGED: Less transparency
    'transition-all duration-200',
    sizeClass,
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={logoClasses}>
      <Image 
        image={image}
        alt={alt || image.alt || 'Logo'}
        fit="contain"
        className="w-full h-full object-contain"
        priority={false}
      />
    </div>
  );
};

Logo.propTypes = {
  image: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]).isRequired,
  alt: PropTypes.string,
  className: PropTypes.string,
  size: PropTypes.oneOf(['sm', 'md', 'lg', 'xl']),
  grayscale: PropTypes.bool,
};

export default Logo;